import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import P from "../P/P";
import styled from "styled-components";
import { setLocal } from "../../actions/local";
import history from "../../history";
import { SUPPORTED_LOCALS } from "../../constants";
export default function LanguageSwitcher() {
  const { local } = useSelector((state) => state.Local);
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);
  const Dropdown = styled.div`
    position: relative;

    button {
      > * {
        color: ${({ theme }) => theme.white};
        font-weight: 100;
      }
      background: transparent;
      border: none;
      cursor: pointer;
      width: 100%;
      text-align: left;
    }

    .langs {
      height: ${(props) => (props.isOpen ? "auto" : "0px")};
      max-height: ${(props) => (props.isOpen ? "12rem" : "0px")};
      position: absolute;
      transition: all 0.4s;
      z-index: ${(props) => (props.isOpen ? "100002" : "-1")};
      background: ${({ theme }) => theme.lightgreen};
      top: 100%;
      left: 0;
      min-width: 120px;
      white-space: nowrap;
      overflow: hidden;

      > * {
        color: ${({ theme }) => theme.white};
        font-weight: 100;
        padding: 0.5rem 1rem;
        cursor: pointer;
        opacity: ${(props) => (props.isOpen ? "1" : "0")};
        pointer-events: ${(props) => (props.isOpen ? "auto" : "none")};
        transition: opacity 0.4s;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  `;
  useEffect(() => {
    const pathName = window.location.pathname;
    const pathLocal = pathName.split("/")[1];
    if (SUPPORTED_LOCALS[pathLocal]) {
      dispatch(setLocal(pathLocal));
    }
  }, [dispatch]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const handleLanguageChange = (newLocal) => {
    const currentLocation = window.location.pathname;
    const newLocation = currentLocation.replace(
      "/" + local + "/",
      "/" + newLocal + "/"
    );
    history.replace(newLocation);
    dispatch(setLocal(newLocal));
    setIsOpen(false); // Close dropdown after selection
  };

  return (
    <Dropdown isOpen={isOpen} ref={dropdownRef}>
      <button
        id="dropdown-language-switcher"
        onClick={() => setIsOpen(!isOpen)}
      >
        <P>{SUPPORTED_LOCALS[local]}</P>
      </button>

      <div className="langs">
        {Object.keys(SUPPORTED_LOCALS).map((l, k) => (
          <P key={l + k} onClick={() => handleLanguageChange(l)}>
            {SUPPORTED_LOCALS[l]}
          </P>
        ))}
      </div>
    </Dropdown>
  );
}
